module.exports = __webpack_public_path__ + "media/react/pages/mock_tests/free/brand/logo/assets/emory_goizueta_logo-59e943c552a673223fc15423d84351d5.png";